"use client";

import { useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import { getLocaleFromPath } from "../lib/i18n/utils";
import RoomNavLink from "./RoomNavLink";

type TranslatedRoomNavLinkProps = {
  direction: "left" | "right";
  href?: string;
  label?: string;
  rel?: "prev" | "next";
  ariaLabel?: string;
};

export default function TranslatedRoomNavLink({
  direction,
  href,
  label,
  rel,
  ariaLabel,
}: TranslatedRoomNavLinkProps) {
  const { t } = useTranslation();
  const pathname = usePathname();
  const locale = getLocaleFromPath(pathname);

  // Greek (el) is the default locale and MUST NOT appear in URLs
  // English (en) MUST be prefixed with /en
  const defaultHref = direction === "left" 
    ? (locale === "el" ? "/rooms" : `/${locale}/rooms`)
    : href;
  const defaultLabel = direction === "left" ? t("Rooms") : undefined;
  const finalLabel = label || defaultLabel || "";
  
  // Use label as aria-label to ensure they match (accessibility best practice)
  // aria-label should match visible text when text is visible
  const finalAriaLabel = ariaLabel || finalLabel;

  return (
    <RoomNavLink
      href={href || defaultHref || ""}
      label={finalLabel}
      direction={direction}
      rel={rel}
      ariaLabel={finalAriaLabel}
    />
  );
}

